import { AUTH_ERROR } from '@/constants/authErrorConstants';
import store from '@/store';
import { cookies } from '@/utils/cookies';
import axios from 'axios';
const axiosAuth = axios.create();
async function reissueToken() {
  const accessToken = cookies.get('aToken');
  const refreshToken = cookies.get('rToken');
  const headers = { 'X-AUTH-TOKEN': accessToken };

  const { data } = await axiosAuth.post('/api/auth/reissue', { accessToken, refreshToken }, { headers });
  if (data.resultCd !== '0000') {
    throw new Error(AUTH_ERROR.TOKEN_REISSUE_FAILED, { cause: data });
  }

  const aToken = data.result.accessToken;
  const rToken = data.result.refreshToken;
  cookies.set('aToken', aToken);
  cookies.set('rToken', rToken);
}
/**
 * 토큰 재발급 후 axios 헤더 값 수정해줌
 * response안에서 처리하게 했을 때 무한 로딩이 자꾸 걸려서 소스를 분리해서 async/await로 처리함
 */

//request 설정
axios.interceptors.request.use(
  async function (config) {
    //헤더 셋팅
    config.headers['X-AUTH-TOKEN'] = cookies.get('aToken');
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
//response 설정
axios.interceptors.response.use(
  function (response) {
    try {
      return response;
    } catch (err) {
      console.error('[axios.interceptors.response] response : ', err.message);
    }
  },
  async function (error) {
    try {
      //에러에 대한 response 정보
      const errorAPI = error.response.config; //요청했던 request 정보가 담겨있음
      //인증에러 및 재요청이 아닐 경우... (+재요청인데 refreshToken이 있을 경우)
      if (error.response.status === 403 && errorAPI.retry === undefined) {
        errorAPI.retry = true; //재요청이라고 추가 정보를 담음
        await reissueToken();
        return axios(errorAPI);
      }
    } catch (err) {
      store.dispatch('logout');
      console.error('[axios.interceptors.response] error : ', err.message);
    }
    return Promise.reject(error);
  }
);

export default axios;
